module.exports = __webpack_public_path__ + "static/img/icon2.b6d21448.svg";